import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Toaster } from '@/components/ui/toast'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { useAuthStore } from '@/store/auth'
import { onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authStore = useAuthStore()

onMounted(() => {
  authStore.initAuth()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_unref(Toaster)),
    _createVNode(_unref(Sonner), {
      position: "top-right",
      richColors: ""
    })
  ], 64))
}
}

})